export default __webpack_public_path__ + "static/photo6.png";